var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenProject(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_162_3377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 8.33334H10.8333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 5.79145C1.66675 5.056 1.66675 4.68828 1.72454 4.38198C1.97895 3.03358 3.03367 1.97886 4.38207 1.72445C4.68837 1.66666 5.0561 1.66666 5.79154 1.66666C6.11376 1.66666 6.27488 1.66666 6.42972 1.68114C7.09729 1.74356 7.73051 2.00586 8.2467 2.43375C8.36641 2.533 8.48033 2.64693 8.70816 2.87478L9.16674 3.33332C9.84658 4.01314 10.1865 4.35305 10.5935 4.57951C10.8171 4.70391 11.0543 4.80215 11.3004 4.8723C11.7483 4.99999 12.229 4.99999 13.1904 4.99999H13.5018C15.6955 4.99999 16.7922 4.99999 17.5052 5.6412C17.5708 5.70019 17.6332 5.7626 17.6922 5.82818C18.3334 6.54111 18.3334 7.63794 18.3334 9.83157V11.6667C18.3334 14.8093 18.3334 16.3807 17.3571 17.357C16.3808 18.3333 14.8094 18.3333 11.6667 18.3333H8.33341C5.19071 18.3333 3.61937 18.3333 2.64306 17.357C1.66675 16.3807 1.66675 14.8093 1.66675 11.6667V5.79145Z",
    stroke: "white",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_162_3377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenProject);
export default __webpack_public_path__ + "static/media/open-project.23a926d1da11e08e73b1101db0816e9a.svg";
export { ForwardRef as ReactComponent };